<template>
    <div class="menu">
        <router-link
            v-for="(item,index) in menuData"
            :key="index"
            :to="item.link"
            class="menu_item"
        >
            <el-badge v-if="item.icon == 'sys' && sysNotReadCount != 0" :value="sysNotReadCount" class="item" >
                <p :class="`menu_icon menu_${item.icon}`"></p>
            </el-badge>
                <p :class="`menu_icon menu_${item.icon}`" v-else></p>
            <p class="menu_name">{{item.name}}</p>
        </router-link>
    </div>
</template>

<script>
    import FN from '@/components/fn';
    import {mapActions} from 'vuex';
    export default {
        mixins: [FN],
        name: 'menu',
        data() {
            return {
                menuData: [
                    {
                        name: '功能首頁',
                        icon: 'home',
                        link: '/home'
                    },
                    // {
                    //   name: '我的任務',
                    //   icon: 'task',
                    //   link: '/task'
                    // },
                    {
                        name: '系統通知',
                        icon: 'sys',
                        link: '/sys'
                    },
                    // {
                    //   name: '聯絡客服',
                    //   icon: 'content',
                    //   link: '/content'
                    // },
                    {
                        name: '個人設定',
                        icon: 'set',
                        link: '/setlist'
                    },
                ],
                sysNotReadCount:0,
            }
        },
        mounted() {
            this.getSysNotReadCount()
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getSysNotReadCount() {
                this.FETCH({
                    key: 'GET_SYS_NOT_READ_COUNT',
                }).then((res) => {
                    this.handleResponse(res)
                })
            },
            handleResponse(res) {
                var code = res.code;

                if (code == '0') {
                    this.sysNotReadCount = res.data.notReadCount;
                } else if (code > '0') {
                    this.$message.error(res.message);
                } else {
                    this.$message.error('系統通知數量取得失敗，請稍後再試。');
                }
                this.loading = false;
            },



        }
    }
</script>
